import React, { useState } from 'react';
import { Box, SpeedDial, SpeedDialAction, SpeedDialIcon } from '@mui/material';
import FeedIcon from '@mui/icons-material/Feed';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Message } from '@mui/icons-material';
import CustomRightDrawer from './CustomRightDrawer';
import ContactUsForm from '../contact2/contactForm';

const FloatingButton = () => {
  const [open, setOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDocumentationClick = () => {
    window.open('/documentation', '_blank');
    setOpen(false);
  };

  const handleContactClick = () => {
    setDrawerOpen(true);
    setOpen(false);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const actions = [
    {
      icon: <FeedIcon />,
      name: 'Documentation',
      onClick: handleDocumentationClick,
    },
    {
      icon: <Message />,
      name: 'Contact',
      onClick: handleContactClick,
    },
  ];

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 1500,
          pointerEvents: open ? 'auto' : 'none',
        }}>
        <SpeedDial
          ariaLabel="Support Menu"
          icon={<SpeedDialIcon icon={<HelpOutlineIcon />} />}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          open={open}
          hidden={drawerOpen}
          direction="up"
          FabProps={{
            sx: {
              borderRadius: '50% !important',
              backgroundColor: open
                ? 'var(--primary-color)'
                : 'var(--secondary-color)',
              boxShadow: 'none',
              color: '#fff',
              transition: 'background-color 0.3s',
              '&:hover': {
                backgroundColor: 'var(--primary-color)',
              },
            },
          }}>
          {actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              tooltipOpen
              tooltipPlacement="left"
              onClick={action.onClick}
              className="fab-custom"
              FabProps={{
                sx: {
                  height: 50,
                  width: 50,
                  boxShadow: 'none',
                  border: '2px solid #ccc',
                },
              }}
            />
          ))}
        </SpeedDial>
      </Box>
      <CustomRightDrawer
        open={drawerOpen}
        onClose={handleDrawerClose}
        title="Contact Us">
        <ContactUsForm />
      </CustomRightDrawer>
    </>
  );
};

export default FloatingButton;
